import { reactLocalStorage } from "reactjs-localstorage";
// import config from "./config/Config";
// import {
//   checkReturningUser,
//   detectBrowser,
//   getTotalDuration,
// } from "./utils/util";

import { getHeaders, body, base, elastic_base } from "../Config";

if (!localStorage.getItem("randomNumber")) {
  //generate 5 digit random no
  const min = 10000;
  const max = 99999;
  const randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;
  console.log("----- random number ----->", randomNumber);
  localStorage.setItem("randomNumber", randomNumber);
}
//----> session id generate logic
var sessionTime = localStorage.getItem("sessionTime")
  ? localStorage.getItem("sessionTime")
  : "";
var sessionId = localStorage.getItem("sessionId")
  ? localStorage.getItem("sessionId")
  : "";
if (sessionTime && sessionId && Date.now() - sessionTime > 300000) {
  // 5 min
  console.log(
    "----- session id updated : --->" +
      Date.now() +
      "" +
      localStorage.getItem("randomNumber")
  );
  const a = Date.now() + "" + localStorage.getItem("randomNumber");
  localStorage.setItem("sessionId", a);
  localStorage.setItem("user_type", "repeatedUser"); // repeated user
}
sessionTime = Date.now();
if (sessionId === "") {
  sessionId = sessionTime + "" + localStorage.getItem("randomNumber");
  localStorage.setItem("sessionId", sessionId);
}
localStorage.setItem("sessionTime", sessionTime);


var deviceId = localStorage.getItem("device_id")
  ? localStorage.getItem("device_id")
  : "";
if (deviceId === "") {
  deviceId = Date.now() + "" + localStorage.getItem("randomNumber");
  console.log("----- device id set : --->" + deviceId);
  localStorage.setItem("device_id", deviceId);
}

export function SendGuiDataEvents(data) {
  if (new Date().getTime() - sessionStorage.getItem("lastPublish") > 300000) {
    //5mins
    sessionStorage.setItem("sessionStartTime", new Date().getTime());
  }
  sessionStorage.setItem("lastPublish", new Date().getTime());
  let msisdn = "na";
  if (localStorage.getItem("tempObj")) {
    const { number, code } = JSON.parse(localStorage.getItem("tempObj"));
    msisdn = code + number;
  }
  var userProfile = "";
  if (localStorage.getItem("userProfile")) {
    userProfile = JSON.parse(localStorage.getItem("userProfile"));
  }
  const guiDataEvent = {
    w_host: window.location.hostname,
    user_agent: navigator.userAgent,
    device_id: deviceId,
    session_id: localStorage.getItem("sessionId"),
    msisdn: reactLocalStorage.get("msisdn")
      ? reactLocalStorage.get("msisdn")
      : msisdn,
    device_type: "web",
    previouspage: "na",
    sid: sessionStorage.getItem("sessionId"),
    camp: sessionStorage.getItem("camp"),
    rcid: sessionStorage.getItem("rcid"),
    w_req_url: window.location.href,
    trace: "",
    opt:"mtn",
    service:"islamic",
    w_country:"GC",
    operatorId: "mtngc",
    referrer_info: "na",
    blocked: localStorage.getItem("blocked"),
    breason: localStorage.getItem("breason"),
    mtype: localStorage.getItem("mtype"),
    w_click_time: new Date().toISOString(),
    session_start_time: sessionStorage.getItem("sessionStartTime"),
  };

  let tracer = reactLocalStorage.get("tracer")
    ? JSON.parse(reactLocalStorage.get("tracer"))
    : "";

  let objData = { ...guiDataEvent, ...data };
  var jsonData_base64 = window.btoa(JSON.stringify(objData)); //base_64

  // let url = elastic_base + "elastic/publish"; // production url

  let url = elastic_base + '/publish';
    fetch(url, { method: "POST", headers: {"guiTopic": "waplogs"} , body: jsonData_base64 })
      .then((resp) => {
        console.log("resp ==>>>", resp);
      })
      .catch((error) => {
        console.log("error", error);
      });

  console.log("Object data event object ---->", objData);
  console.log("Object data event object base64 ---->", jsonData_base64);
}
